import { render, staticRenderFns } from "./SingleChoiceCheckpoint.vue?vue&type=template&id=2818bd38&scoped=true&"
import script from "./SingleChoiceCheckpoint.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./SingleChoiceCheckpoint.vue?vue&type=style&index=0&id=2818bd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818bd38",
  null
  
)

export default component.exports